import type { FaireProductEntity } from "../../entity_types/product";

export const p_bjrg7xg1h2: FaireProductEntity = {
  token: "p_bjrg7xg1h2",
  type: "product",
  name: "Natural Bath Bomb handmade Chamomile - Stress Relief",
  brandToken: "b_2oar1fmd",
  brandName: "Evolve Botanica",
  imageUrl:
    "https://cdn.faire.com/fastly/10b3699a917bbae312d17b4b1e12f763a63ab000ed5e4221525e347b205991d3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21f43cec15447ce7216b09439540b17bc476de4eac161dee9b85500dc0649b5a.png",
    "https://cdn.faire.com/fastly/6c370e0b441d82efebdf78aba45daa1a4fe7e25c8d77ea1f7d2beb443c43c4c9.png",
    "https://cdn.faire.com/fastly/31c9ee4c330dacb5093931c9a6a137fdee2d1de29395ca095dd146648511b254.png",
  ],
  priceDollars: 3.5,
  description:
    "Find your peace with our Bath Bomb - Stress Relief. This bath bomb features a soothing blend of spearmint, complemented by calming chamomile, perfect for a relaxing and stress-relieving bath. Crafted with high-quality ingredients, including Sodium Bicarbonate, Citric Acid, Sea Salt, Sunflower Oil, Fragrance Oil, Natural Shea Butter, and Colorant, these bath bombs are ideal for summertime gifts.\n\nFeature Highlights:\nMade with natural ingredients for a soothing and stress-relieving bath experience.\nIdeal for the summer season with calming eucalyptus and spearmint scents.\nPerfect for summer gifts, Easter baskets, Mother's Day, and birthday presents.\nGentle on sensitive skin with moisturizing Shea Butter.\nAvailable in bulk, wholesale, and private label options for retailers.\n\nEntice your customers with the relaxing aroma and luxurious feel of these natural summer bath bombs, perfect for gifting and self-care.",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:00.837Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
